import React from 'react';
import { Bell } from '@phosphor-icons/react';
import { ScrollArea } from '../ui/scroll-area';
import NotificationItem from './NotificationItem';

const Spinner = () => (
  <div className="flex items-center justify-center h-32">
    <div className="w-6 h-6 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin" />
  </div>
);

const EmptyState = () => (
  <div className="flex flex-col items-center justify-center h-32 text-slate-500">
    <Bell size={32} className="mb-2 text-slate-300" />
    <p className="text-sm">No notifications</p>
  </div>
);

const NotificationList = ({ notifications, loading, onMarkRead, onDelete }) => (
  <ScrollArea className="h-[400px]">
    {loading && notifications.length === 0 ? (
      <Spinner />
    ) : notifications.length === 0 ? (
      <EmptyState />
    ) : (
      notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onMarkRead={onMarkRead}
          onDelete={onDelete}
        />
      ))
    )}
  </ScrollArea>
);

export default NotificationList;
